function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as r, jsxs as s } from "react/jsx-runtime";
import * as R from "react";
import f from "classnames";
import { useScreenSize as T } from "./hooks.js";
import { MediaBorderRadiusProvider as v } from "./image.js";
import { Text3 as x, Text8 as D } from "./text.js";
import O from "./grid-layout.js";
import l from "./box.js";
import y from "./stack.js";
import j from "./button-group.js";
import { vars as c } from "./skins/skin-contract.css-mistica.js";
import { vars as b, container as h, containerMobile as G, containerDesktop as S, layout as L, actions as A } from "./hero.css-mistica.js";
import { assignInlineVars as B } from "@vanilla-extract/dynamic";
import { useIsInsideSlideshowContext as V } from "./carousel.js";
import { getPrefixedDataAttributes as N } from "./utils/dom.js";
import { sprinkles as H } from "./sprinkles.css-mistica.js";
import { ThemeVariant as Y } from "./theme-variant-context.js";
const k = (param)=>/* @__PURE__ */ {
    let { children: e , isInverse: o  } = param;
    return r(Y, {
        isInverse: o,
        children: /* @__PURE__ */ r("div", {
            className: L,
            children: e
        })
    });
}, u = (param)=>/* @__PURE__ */ {
    let { headline: e , title: o , pretitle: n , description: i , descriptionLinesMax: d , extra: a , button: t , secondaryButton: p , buttonLink: m  } = param;
    return s("section", {
        className: H({
            height: "100%",
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "column"
        }),
        children: [
            /* @__PURE__ */ s("div", {
                children: [
                    /* @__PURE__ */ s(y, {
                        space: 16,
                        children: [
                            e && e,
                            /* @__PURE__ */ s(y, {
                                space: 8,
                                children: [
                                    n && /* @__PURE__ */ r(x, {
                                        as: "p",
                                        regular: !0,
                                        children: n
                                    }),
                                    o && /* @__PURE__ */ r(D, {
                                        as: "h1",
                                        children: o
                                    })
                                ]
                            }),
                            i && /* @__PURE__ */ r(x, {
                                as: "p",
                                regular: !0,
                                color: c.colors.textSecondary,
                                truncate: d,
                                children: i
                            })
                        ]
                    }),
                    a && /* @__PURE__ */ r("div", {
                        children: a
                    })
                ]
            }),
            (t || m) && /* @__PURE__ */ r("div", {
                className: A,
                children: /* @__PURE__ */ r(j, {
                    primaryButton: t,
                    secondaryButton: p,
                    link: m
                })
            })
        ]
    });
}, C = {
    default: c.colors.background,
    alternative: c.colors.backgroundAlternative,
    brand: c.colors.backgroundBrand,
    "brand-secondary": c.colors.backgroundBrandSecondary
}, $ = /*#__PURE__*/ R.forwardRef((_param, t)=>{
    var { height: e , background: o = "default" , media: n , desktopMediaPosition: i = "left" , dataAttributes: d  } = _param, a = _object_without_properties(_param, [
        "height",
        "background",
        "media",
        "desktopMediaPosition",
        "dataAttributes"
    ]);
    const { isTabletOrSmaller: p  } = T(), m = V(), g = o === "brand" || o === "brand-secondary";
    if (p) return /* @__PURE__ */ r(v, {
        value: !1,
        children: /* @__PURE__ */ s("div", _object_spread_props(_object_spread({}, N(_object_spread({
            "component-name": "Hero"
        }, d))), {
            ref: t,
            style: _object_spread({
                backgroundColor: C[o]
            }, e === "100vh" ? {
                maxHeight: "-webkit-fill-available"
            } : {}, B({
                [b.height]: e !== null && e !== void 0 ? e : "100%"
            })),
            className: f(h, G),
            children: [
                n,
                /* @__PURE__ */ r(k, {
                    isInverse: g,
                    children: /* @__PURE__ */ r(l, {
                        paddingTop: 24,
                        paddingBottom: m ? 48 : 24,
                        children: /* @__PURE__ */ r(u, _object_spread({}, a))
                    })
                })
            ]
        }))
    });
    const w = i === "left" ? n : /* @__PURE__ */ r(l, {
        paddingRight: 24,
        children: /* @__PURE__ */ r(u, _object_spread({}, a))
    }), I = i === "right" ? n : /* @__PURE__ */ r(l, {
        paddingLeft: 24,
        children: /* @__PURE__ */ r(u, _object_spread({}, a))
    });
    return /* @__PURE__ */ r(v, {
        value: !0,
        children: /* @__PURE__ */ r("div", _object_spread_props(_object_spread({}, N(_object_spread({
            "component-name": "Hero"
        }, d))), {
            ref: t,
            style: _object_spread({
                backgroundColor: C[o]
            }, e === "100vh" ? {
                maxHeight: "-webkit-fill-available"
            } : {}, B({
                [b.height]: e !== null && e !== void 0 ? e : "100%"
            })),
            className: H({
                height: "100%",
                display: "flex",
                alignItems: "center"
            }),
            children: /* @__PURE__ */ r(k, {
                isInverse: g,
                children: /* @__PURE__ */ r(O, {
                    template: "6+6",
                    left: /* @__PURE__ */ r(l, {
                        paddingY: 56,
                        className: f(h, S),
                        children: w
                    }),
                    right: /* @__PURE__ */ r(l, {
                        paddingY: 56,
                        className: f(h, S),
                        children: I
                    })
                })
            })
        }))
    });
}), or = $;
export { or as default };
